import { mode } from "@chakra-ui/theme-tools";

const fieldStyles = (props) => ({
  bg: mode("white", "navy.700")(props),
  color: mode("gray.800", "white")(props),
  border: "1px solid",
  borderColor: mode("gray.200", "whiteAlpha.300")(props),
  borderRadius: "8px",
  _placeholder: { color: mode("gray.500", "whiteAlpha.600")(props) },
  _hover: {
    borderColor: mode("gray.300", "whiteAlpha.400")(props),
    bg: mode("gray.50", "navy.600")(props),
  },
  _focusVisible: {
    borderColor: mode("brand.500", "brand.300")(props),
    bg: mode("white", "navy.700")(props),
    color: mode("gray.800", "white")(props),
  },
});

export const textareaStyles = {
  components: {
    Textarea: {
      baseStyle: (props) => ({
        ...fieldStyles(props),
        fontWeight: 400,
      }),
      defaultProps: {
        variant: "outline",
      },
      variants: {
        outline: (props) => fieldStyles(props),
        main: (props) => ({
          ...fieldStyles(props),
          borderRadius: "16px",
          fontSize: "sm",
          p: "20px",
        }),
        auth: (props) => ({
          ...fieldStyles(props),
          borderRadius: "16px",
        }),
        authSecondary: (props) => ({
          ...fieldStyles(props),
          bg: mode("transparent", "navy.800")(props),
          borderRadius: "16px",
        }),
        search: (props) => ({
          ...fieldStyles(props),
          border: "none",
          py: "11px",
        }),
      },
    },
  },
};
